import * as React from 'react';

/**
 * @description Online icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Online } from '@sravni/design-system-icons'
 *
 * <Online />
 * ```
 */
const Online = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "Online", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("g", { clipPath: "url(#Online__a)" },
        React.createElement("path", { d: "M19.736 16.652A2.348 2.348 0 0 1 17.388 19H4.084a2.348 2.348 0 0 1-2.348-2.348V3.348A2.348 2.348 0 0 1 4.084 1h13.304a2.348 2.348 0 0 1 2.348 2.348v13.304Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "m4.902 11.464 5.319-4.482a.79.79 0 0 1 1.03 0l5.318 4.482", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinecap: "round" }),
        React.createElement("path", { d: "M15.402 10.386v4.93c0 .454-.418.821-.934.821H7.002c-.516 0-.934-.367-.934-.821v-4.93", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10" }),
        React.createElement("path", { d: "M4.736 4h6", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("circle", { cx: "16.736", cy: "4", r: "1", fill: "currentColor" }),
        React.createElement("circle", { cx: "13.736", cy: "4", r: "1", fill: "currentColor" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "Online__a" },
            React.createElement("path", { fill: "currentColor", transform: "translate(.736)", d: "M0 0h20v20H0z" }))))));

export { Online };
//# sourceMappingURL=Online.js.map
